import styles from "./AvailabilityErrorPanel.module.scss";

import { useCallback } from "react";

import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { ROUTES } from "@/modules/shared/consts/routes";

const FIRST_FAILURE = "first";
const REPEAT_FAILURE = "repeat";

interface AvailabilityErrorPanelProps {
  isRepeatFailure?: boolean;
  isRetrying?: boolean;
  onRetry: () => void;
  supportRoute?: string;
}

export const AvailabilityErrorPanel = ({
  isRepeatFailure = false,
  isRetrying = false,
  onRetry,
  // Matches NeedHelpLink's default so both links in a widget agree.
  supportRoute = ROUTES.support.embed.index,
}: AvailabilityErrorPanelProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const state = isRepeatFailure ? REPEAT_FAILURE : FIRST_FAILURE;

  const handleContactSupport = useCallback(() => {
    navigate({ to: supportRoute });
  }, [navigate, supportRoute]);

  return (
    <div className={styles.container} role="alert">
      <div className={styles.content}>
        <div className={styles.header}>
          <p className={styles.title}>
            {t(`bookingWidget.availabilityError.${state}.title`)}
          </p>
          <p className={styles.description}>
            {t(`bookingWidget.availabilityError.${state}.description`)}
          </p>
        </div>

        <div className={styles.actions}>
          <AppButton
            variant="critical"
            onClick={onRetry}
            isLoading={isRetrying}
          >
            {t("bookingWidget.availabilityError.retryCta")}
          </AppButton>

          {isRepeatFailure && (
            <AppButton variant="surface" onClick={handleContactSupport}>
              {t("bookingWidget.availabilityError.supportCta")}
            </AppButton>
          )}
        </div>
      </div>
    </div>
  );
};
